import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "../../lib/constants";

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 bg-black"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#3DC0AF] font-mono font-bold">
              / CLIENTS
            </div>
            <h2 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-display font-black tracking-tighter leading-[0.95] max-w-2xl">
              Real words. Real jobsites.
            </h2>
          </div>
          <div className="flex items-center gap-2 text-zinc-400 text-sm">
            {[0, 1, 2, 3, 4].map((i) => (
              <Star
                key={i}
                className="h-4 w-4 fill-yellow-400 text-yellow-400"
              />
            ))}
            <span className="ml-2">5.0 average rating</span>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.quote}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="tb-glass rounded-2xl p-7 md:p-8 relative"
            >
              <Quote className="absolute top-6 right-6 h-6 w-6 text-[#3DC0AF]/50" />
              <div className="flex items-center gap-1">
                {[0, 1, 2, 3, 4].map((k) => (
                  <Star
                    key={k}
                    className="h-3.5 w-3.5 fill-yellow-400 text-yellow-400"
                  />
                ))}
              </div>
              <blockquote className="mt-6 font-display text-xl md:text-2xl font-bold leading-snug tracking-tight">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-8 text-sm">
                <div className="font-medium text-white">{t.author}</div>
                <div className="text-zinc-500">{t.role}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
